import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import ChargeOnCompanyMappingContMain from "presentation/view/container/ChargeOnCompanyMapping/ChargeOnCompanyMappingContMain";

CommonEntrypoint(<ChargeOnCompanyMappingContMain/>)